export default __webpack_public_path__ + "static/media/tatoos.eba807a6.PNG";